import { createListenerMiddleware, PayloadAction } from '@reduxjs/toolkit'
import { AppDispatch, RootState } from '@/store/store'
import { AgentConversationFormActions } from './slice'

export const agentFormListenerMiddleware = createListenerMiddleware()
const startListener = agentFormListenerMiddleware.startListening.withTypes<RootState, AppDispatch>()

/**
 * Sync research filters to request params
 *
 * This listener watches for ANY change to research filters (state selection,
 * federal content toggles, etc.) and automatically syncs the UI state to the
 * request params that will be sent to the backend.
 *
 */
startListener({
  matcher: (action): action is PayloadAction<{ conversationId: string }> => {
    if (!action.type.startsWith('researchFilters/')) return false
    // Exclude toggleStateSelected (source arrays aren't ready yet; sync on applyStateToggleSideEffects instead)
    if (action.type === 'researchFilters/toggleStateSelected') return false
    return true
  },
  effect: (action, listenerApi) => {
    const conversationId = action.payload.conversationId
    if (!conversationId) return

    const state = listenerApi.getState()
    const filters = state.researchFiltersState.filters[conversationId]

    if (filters) {
      listenerApi.dispatch(
        AgentConversationFormActions.syncResearchFiltersToRequestParams({
          conversationId,
          stateLrrSources: filters.stateLrrSources,
          stateCaselawSources: filters.stateCaselawSources,
          federalLrrSources: filters.federalLrrSources,
          federalCaselawSources: filters.federalCaselawSources,
        })
      )
    }
  },
})
